<template>
  <div class="quickbooks-setup" :class="{ 'in-auth-flow': inOAuthFlow }">
    <div v-if="loading">Loading QuickBooks...</div>
    <div v-else>
      <div v-if="inOAuthFlow">
        Please finish the Intuit authentication in the pop-up window to
        continue. If you don't see the authentication window, please check your
        browser settings to ensure the pop-up was allowed.
      </div>
      <div v-else>
        <div v-if="quickbooksCompanies.length" class="quickbooks-companies">
          <QuickbooksCompany
            v-for="company in quickbooksCompanies"
            :key="company.id"
            :company="company"
          />
        </div>
        <div v-else class="mb-4">
          <div v-if="multipleQbo">
            There are no connected QuickBooks companies.
          </div>
          <div v-else>
            <p class="mb-4">
              Click "Connect to QuickBooks" below to get started. You'll be
              taken to QuickBooks where you can authorize the connection between
              Sera and QuickBooks.
            </p>
            <p class="mb-4">
              If you have multiple QuickBooks companies, you'll also be prompted
              to select which one to connect to Sera.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";

import QuickbooksCompany from "./QuickbooksCompany.vue";
import { injectUseQuickbooksConfig } from "./useQuickbooksConfig";

const loading = ref(true);
const {
  fetchQuickbooksCompanies,
  inOAuthFlow,
  quickbooksCompanies,
  multipleQboFeatureFlag
} = injectUseQuickbooksConfig();

const multipleQbo = ref(false);

onMounted(async () => {
  try {
    await fetchQuickbooksCompanies();
    multipleQbo.value = await multipleQboFeatureFlag();
  } catch (e) {
    // Do nothing
  }
  loading.value = false;
});
</script>

<style lang="scss" scoped>
.quickbooks-setup {
  &.in-auth-flow {
    opacity: 0.6;
    pointer-events: none;
  }
}

.quickbooks-companies {
  > * {
    margin-bottom: 8px;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
